/**
 * Simple count of stories over the previous 24 hours
 * @author Ryan Gladstone
 * <viz-story-count></viz-story-count>
 * Webpack migration by Umer Hassan
 */
function VizStoryCountController($scope, $translate, storiesService, moment, $log) {
  function storyCountError() {
    $scope.storyCount = $translate.instant('ERROR');
    $scope.storyCountLabel = $translate.instant('PUBLISHED_STORIES');
  }

  storiesService.getPublishedStoryCount(moment().add(-24, 'hours').unix(), moment().unix(),
    $scope.filterSet.getFilterValue('sections'), $scope.filterSet.getFilterValue('platforms')
  )
    .then((res) => {
      const data = res.data;
      // If the story count comes back as a positive integer, display it
      if (data.totalResults !== undefined && data.totalResults !== null &&
        isFinite(data.totalResults) && data.totalResults > -1) {
        $scope.storyCount = data.totalResults;
        if (data.totalResults === 1) {
          $scope.storyCountLabel = $translate.instant('PUBLISHED_STORY');
        } else {
          $scope.storyCountLabel = $translate.instant('PUBLISHED_STORIES');
        }
        // Otherwise display "error"
      } else {
        storyCountError();
      }
    }, (response) => {
      $log.error('VizStoryCountController() error: ', response);
      storyCountError();
    });
}

function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template: '<h4>{{ storyCount }}</h4>{{ storyCountLabel }}',
    controller: ['$scope',
      '$translate',
      'storiesService',
      'moment',
      '$log',
      VizStoryCountController]
  };
}


export default function (ngModule) {
  ngModule.directive('vizStoryCount', directive);
}
